export default __webpack_public_path__ + "static/media/get-started.dbd7f444.png";